<template>
  <v-card-text class="pa-2 pa-sm-4">
    <period @get-date="getDate" />

    <period-time @get-time="getTime" class="mt-2" />

    <v-row dense align="center" class="mt-2">
      <v-col cols="12" sm="6" md="6">
        <v-select
          v-model="selectControllerId"
          :items="controllers"
          item-text="name"
          item-value="id"
          label="Контроллер"
          clearable
          dense
          hide-details
        />
      </v-col>

      <v-col cols="12" sm="6" md="6">
        <category-type @get-category="getCategory" />
      </v-col>

      <v-col cols="12" sm="auto">
        <v-btn @click="sendParams" text color="primary">
          Загрузить данные
        </v-btn>
      </v-col>
    </v-row>
  </v-card-text>
</template>

<script>
import Period from "./Period";
import PeriodTime from "./PeriodTime";
import CategoryType from "./CategoryType";
import { getControllers } from "../../../services/device.service";

export default {
  name: "DisciplineToolbar",
  components: { PeriodTime, Period, CategoryType },
  data: () => ({
    controllers: [],

    selectControllerId: null,

    date: {},
    time: {},
    category: {},
    params: {}
  }),

  created() {
    this.getControllers();
  },

  methods: {
    async getControllers() {
      try {
        this.controllers = await getControllers();

        this.filterControllers();
      } catch (e) {
        this.$notify({
          text: e.response ? e.response.data.message : e,
          type: "error"
        });
      }
    },

    filterControllers() {
      this.controllers = this.controllers.filter(
        controller => controller.type !== 2 && controller.name
      );
    },

    generateParams() {
      this.params = {
        ...this.date,
        ...this.time,
        ...this.category,
        controllerId: this.selectControllerId
      };
    },

    getDate(date) {
      this.date = date;
    },

    getTime(time) {
      this.time = time;
    },

    getCategory(categoryParams) {
      this.category = categoryParams;
    },

    sendParams() {
      this.generateParams();
      this.$emit("load", this.params);
    }
  }
};
</script>
